<div>
  <table mat-table matSort [dataSource]="dataSource" class="main-table-container">
    @for (columnName of displayedColumns; track $index) {
      <ng-container [matColumnDef]="columnName">
        <th mat-header-cell *matHeaderCellDef>
          @if (columnName | shouldHeaderBeDisplayed) {
            {{ columnName | translate | uppercase }}
          }
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          [ngClass]="columnName === 'expand' ? 'expand-column' : 'standard-column'"
          [ngClass]="moduleName === 'run-time' ? '' : 'single-column-for-logs'"
        >
          <app-main-table-module-specific-template
            [module]="moduleName"
            [specificTemplateName]="specificTemplateName"
            [columnName]="columnName"
            [element]="element"
            (click)="handleColumnClick($event, columnName, element)"
          ></app-main-table-module-specific-template>
        </td>
      </ng-container>
    }
    <tr
      mat-header-row
      *matHeaderRowDef="displayedColumns"
      class="background"
      [class.cdk-visually-hidden]="hideColumns"
    ></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      [ngClass]="moduleName === 'run-time' ? 'background pointer-cursor' : 'background-for-logs'"
      (click)="routeTo(row)"
    ></tr>
  </table>
</div>
